import { render } from "./OrderSummary.vue?vue&type=template&id=67520f80&scoped=true&ts=true"
import script from "./OrderSummary.vue?vue&type=script&lang=ts"
export * from "./OrderSummary.vue?vue&type=script&lang=ts"

import "./OrderSummary.vue?vue&type=style&index=0&id=67520f80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67520f80"]])

export default __exports__